import { Environment } from './types/config';

// This is the environment/configuration for the React code.

export const environment: Environment =
  (document.querySelector<HTMLMetaElement>('meta[name="environment"]')?.content as Environment) ?? 'dev';

type UiUrls = {
  authorizeUrl: string;
  apiUrl: string;
  appUrl: string;
  livefireUrl: string;
  loginUrl: string;
  metroUrl: string;
  yardstickUrl: string;
};

const environmentUrlMap: Record<Environment, UiUrls> = {
  prod: {
    authorizeUrl: 'https://app.bombbomb.com/auth/authorize',
    apiUrl: 'https://api.bombbomb.com',
    appUrl: 'https://app.bombbomb.com',
    loginUrl: 'https://login.bombbomb.com',
    metroUrl: 'https://metro.bombbomb.io',
    yardstickUrl: 'https://yardstick.bombbomb.io',
    livefireUrl: 'https://livefire.bombbomb.com',
  },
  dev: {
    authorizeUrl: 'https://dev.app.bombbomb.com/auth/authorize',
    apiUrl: 'https://dev.api.bombbomb.com',
    appUrl: 'https://dev.app.bombbomb.com',
    loginUrl: 'https://development-login.dev.bombbomb.com',
    metroUrl: 'https://development-metro.dev.bombbomb.io',
    yardstickUrl: 'https://yardstick.bombbomb.io',
    livefireUrl: 'https://dev-livefire.bombbomb.com',
  },
  local: {
    authorizeUrl: 'https://local.app.bombbomb.com/auth/authorize',
    apiUrl: 'https://local.api.bombbomb.com',
    appUrl: 'https://local.app.bombbomb.com',
    loginUrl: 'https://development-login.dev.bombbomb.com',
    metroUrl: 'https://development-metro.dev.bombbomb.io',
    yardstickUrl: 'https://yardstick.bombbomb.io',
    livefireUrl: 'https://dev-livefire.bombbomb.com',
  },
};

export function getUrlsForEnvironment(env: Environment) {
  return environmentUrlMap[env];
}
